var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ib-loading-text",class:_vm.classes,style:({fontSize: _vm.fontSize})},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }